export const HOME_AUTHENTICATE_USER = 'HOME_AUTHENTICATE_USER';
export const HOME_AUTHORIZATION_ERROR = 'HOME_AUTHORIZATION_ERROR';
export const HOME_CLIENT_CONFIG = 'HOME_CLIENT_CONFIG';
export const HOME_CLIENT_CONFIG_FETCH_ERROR = 'HOME_CLIENT_CONFIG_FETCH_ERROR';
export const HOME_ERRORMAP_CONFIG = 'HOME_ERRORMAP_CONFIG';
export const HOME_ERRORMAP_CONFIG_FETCH_ERROR = 'HOME_ERRORMAP_CONFIG_FETCH_ERROR';

export const HOME_SET_LOGGEDINUSER_ROLES = 'HOME_SET_LOGGEDINUSER_ROLES';
export const HOME_SET_LOGGEDINUSER_INFO = 'HOME_SET_LOGGEDINUSER_INFO';
export const HOME_SET_MANDATORY_APPOINTMENT_INFO = 'HOME_SET_MANDATORY_APPOINTMENT_INFO';
export const HOME_SET_SIMULATIONUSER_INFO = 'HOME_SET_SIMULATIONUSER_INFO';
export const HOME_RESET_SIMULATIONUSER_INFO = 'HOME_RESET_SIMULATIONUSER_INFO';
export const RESET_HOME_REDUCER = 'RESET_HOME_REDUCER';

export const USER_ACCESS_LEVELS = 'USER_ACCESS_LEVELS';

export const SET_BRAND_CONFIGS = 'SET_BRAND_CONFIGS';

export const SWITCH_ASSIGNED_BROKER = 'SWITCH_ASSIGNED_BROKER';
export const PERSIST_SIMULATION_INFO = 'PERSIST_SIMULATION_INFO';

export const UPDATE_HIPPA_USER_PROFILE = 'UPDATE_HIPPA_USER_PROFILE';
export const HOME_SET_ACE_PROFILE = 'HOME_SET_ACE_PROFILE';
export const HOME_FETCH_ACE_PROFILE_FAILED = 'HOME_FETCH_ACE_PROFILE_FAILED';
export const HOME_ACE_SET_CONCIERGE_DETAIL = 'HOME_ACE_SET_CONCIERGE_DETAIL';
export const HOME_ACE_FETCH_CONCIERGE_DETAIL_FAILED = 'HOME_ACE_FETCH_CONCIERGE_DETAIL_FAILED';
export const SHOW_SQ_SIDEBAR = 'SHOW_SQ_SIDEBAR';
export const USER_SIMULATION_DATA = 'USER_SIMULATION_DATA';
export const SET_MULTIPLE_DELEGATE = 'SET_MULTIPLE_DELEGATE';
export const GET_USER_LIST = 'GET_USER_LIST';
export const FETCH_USER_PRODUCER_DATA = 'FETCH_USER_PRODUCER_DATA';
export const UPDATE_SET_SITE_ACCESS_FLAG = 'UPDATE_SET_SITE_ACCESS_FLAG';
export const SET_LD_FLAGS = 'SET_LD_FLAGS';
export const SIMULATE_PAGES = ['agentConnect', 'appointments', 'contactus', 'contracting', 'medicaresupplies'];
export const UPDATE_CONTACT_INFO = 'UPDATE_CONTACT_INFO';
